/* eslint-disable import/prefer-default-export */
import { UserActivityType } from '@amzn/cuminuicomponents';
import { MerchantAccount } from './MerchantAccounts';
import { OldIdentities } from './UserOnboarding';

export const DAYS_AFTER_PROFILE_CREATED_TO_MIGRATE_USERNAME = 90;

export interface UserProfilePayloadResponse {
  userId: string;
  username: string;
  internalUser?: boolean;
  aboutMe?: string;
  aboutMyBusiness?: string;
  businessNames?: string[];
  stats?: UserStats;
  avatarSrc: string;
  deleted?: boolean;
  oldIdentity?: string;
  createdAt: number;
  isDiscourseProfile?: boolean;
  alternateProfile?: {
    userId: string;
  }
  merchantAccounts?: MerchantAccount[],
}

export interface UserStats {
  upVotes: number;
  downVotes: number;
  discussionsStarted: number;
  repliesToDiscussion: number;
  solutionProvided: number;
}

export interface UserProfileState {
  username: string;
  businesses: Array<string>;
  aboutMe: string;
  aboutMyBusiness: string;
  oldIdentities: Array<OldIdentities & { isSelected: boolean }>
}

export interface UpdateUserProfileRequest {
  userId: string;
  avatarSrc?: string | undefined;
  username?: string | undefined;
  aboutMe?: string | undefined;
  aboutMyBusiness?: string | undefined;
}

export interface UpdateUserProfileResponse {
  updated: boolean;
}

export interface UserActivityRequest {
  userId: string;
  cursor?: string | null;
  activityType?: UserActivityTypes;
}

export interface UserActivityResponse {
  userActivities: UserActivity[];
  userId: string;
  username: string;
  cursor: string | null;
}

export interface UserActivity {
  threadId: string;
  postId: string;
  categoryId: string;
  marketplaceId: string;
  groupId?: string | null;
  groupName?: string | null;
  opUserId?: string;
  opUserName?: string;
  activityType: UserActivityType;
  activityTime: number;
  activityContent: string;
}

export enum MigrationOptions {
  Accept = 'ACCEPT',
  Decline = 'DECLINE',
}

export interface ClaimUsernameRequest {
  oldIdentity: string;
  decisionToClaim: boolean;
}

export interface ClaimUsernameResponse {
  username: string;
}

export interface PersonalizationPreferencesResponse {
  'followedCategories': Array<string>,
}

export enum UserActivityTypes {
  createdDiscussion = 'CREATED_DISCUSSION',
  repliedToDiscussion = 'REPLIED_TO_DISCUSSION',
  all = 'ALL',
}
